import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login';
import permission from './modules/permission';
import curRouter from './modules/curRouter';
import keepStatus from './modules/keepStatus';
import tags from './modules/tags';
import getters from './getters';

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
	    login,
	    permission,
		curRouter,
		keepStatus,
		tags
	},
	getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js